// import React, { useState, useEffect } from "react";
import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Collapse, Form, FormGroup, Label, Modal, ModalBody, ModalHeader, Input } from 'reactstrap';
import "./Order.css"; // Import external CSS
import { getOrderList, getTrackingOrder } from "../../../Apis/Order";
import Loader from "../../../Modules/Settings/Loader";
import { BsBoxSeam } from "react-icons/bs";
import { GrLocation } from "react-icons/gr";
import { MdOutlineCreditCard } from "react-icons/md";
import { MdOutlineNavigateNext } from "react-icons/md";
// import { Cancel, Collection, Description, EditBookmark, General, Group, MyBookmarks, Save, Title, WebUrl } from '../../Constant';
import { useForm } from 'react-hook-form';
import { Cancel, Collection, Description, EditBookmark, General, Group, MyBookmarks, Save, Title, WebUrl } from '../../../Constant';
import { Btn } from '../../../AbstractElements';
import { IoIosSend } from "react-icons/io";
import { getInvoice } from "../../../Apis/Invoice";
import { getOrderDetails } from '../../../Apis/Setting';
import { getOrderTrackingDetails } from '../../../Apis/Setting';
import Swal from 'sweetalert2';




const OrdersList = () => {


  const [orders, setOrders] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState({}); // Track loading for each button
  const [loadingTrackingStates, setLoadingTrackingStates] = useState({}); // Track loading for each button
  const [PaymentData, setPaymentData] = useState(null);
  const [OrderTrackingData, setOrderTrackingData] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [loadingState, setLoadingState] = useState({});
  const [loadingPaymentState, setLoadingPaymentState] = useState({});
  const [orderItems, setOrderItems] = useState([]);

  const fetchInvoice = async (user_order_id) => {
    //alert(user_order_id);
    setLoadingStates((prev) => ({ ...prev, [user_order_id]: true })); // Set loading only for this button

    try {

      const invoicePayload = { "orderIds": [user_order_id] }
      console.log("invoicePayloadnew", invoicePayload);
      const orderData = await getInvoice(invoicePayload);
      //console.log("orderData...", orderData);
      let invoiceURL = orderData?.response?.invoice_url;

      if (invoiceURL) {
        window.open(invoiceURL, "_blank"); // Opens in a new tab without reloading
      } else {
        console.error("Invoice URL not found");
      }

    } catch (error) {
      console.error("Error fetching products:", error);
   
    } finally {
      setLoadingStates((prev) => ({ ...prev, [user_order_id]: false })); // Stop loading only for this button
    }
  };

  const fetchOrderTracking = async (orderId, orderItems) => {
    setOrderItems(orderItems);

    setLoadingTrackingStates((prev) => ({ ...prev, [orderId]: true }));
    //setIsloading(true);
    try {
      const orderTrackingData = await getOrderTrackingDetails(orderId);
      console.log("ordertrackingggggg...", orderTrackingData);
      setOrderTrackingData(orderTrackingData);
      if (orderTrackingData?.error) {
        setOrderProcessing(true, orderItems)
        // Swal.fire({
        //   icon: "error",
        //   title: "Error!",
        //   text: orderTrackingData?.message,
        // });
      } else {

        //const track_url = orderTrackingData?.response?.tracking_data?.track_url;
        const track_url = orderTrackingData?.data?.response?.tracking_data?.track_url;

        if (track_url) {
          window.open(track_url, "_blank", "noopener,noreferrer");
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning!",
            text: "Tracking URL not available.",
          });
        }
      }

    } catch (error) {
      console.log("errrrrror", error);
      console.error("Error fetching products:", error);

      // Extract error message from response
      const errorMessage =
        error?.response?.data?.message || "Something went wrong. Please try again.";

      // Show error in Swal
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: errorMessage,
      });
    } finally {
      setLoadingTrackingStates((prev) => ({ ...prev, [orderId]: false }));
    }
  };


  useEffect(() => {
    const fetchOrderList = async () => {
      setLoading(true);
      try {
        const orderData = await getOrderList();
        console.log("orderData...", orderData);
        setOrders(orderData);
      } catch (error) {
        console.error("Error fetching products:", error);
        // Swal.fire({
        //   icon: "error",
        //   title: "Error!",
        //   text: "Failed to fetch product list.",
        // });
      } finally {
        setLoading(false);
      }
    };
    fetchOrderList();
  }, []);
  console.log("orderData", orders);
  function getStatusClass(status) {
    switch (status) {
      case "Pending":
        return "#f5f5f3";
      case "Success":
        return "#198754";
      case "Failed":
        return "#dc3545";
      case "Placed":
        return "#ebebeb";
      default:
        return "";
    }
  }

  const [editModal, seteditModal] = useState(false);

  const editToggle = () => {
    seteditModal(!editModal);
  };

  const { register, handleSubmit, formState: { errors } } = useForm();

  const handleViewTrackingBtn = async (orderId) => {

    setLoadingPaymentState((prev) => ({ ...prev, [orderId]: true })); // Set loading only for this button
    //setLoading(true);
    try {
      const response = await getOrderDetails(orderId);
      console.log("Order Details Response:", response);

      if (response?.statusCode === 200) {
        setPaymentData(response.data[0]?.userOrders?.paymentData); // Store fetched order details
        seteditModal(true); // Open modal
      } else {
        alert("Failed to fetch order details.");
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      alert("Error fetching order details. Please try again.");
    } finally {
      setLoadingPaymentState((prev) => ({ ...prev, [orderId]: false })); // Set loading only for this button
      //setLoading(false);
    }
  };
  // const handleViewTrackingBtn = async( user_order_id ) => {
  //   //alert("user_order_id", user_order_id);
  //     //setLoading(true);
  //     try {
  //       const orderData = await getTrackingOrder( user_order_id );
  //       console.log("orderData...", orderData);
  //       //setOrders(orderData);
  //     } catch (error) {
  //       console.error("Error fetching products:", error);
  //       // Swal.fire({
  //       //   icon: "error",
  //       //   title: "Error!",
  //       //   text: "Failed to fetch product list.",
  //       // });
  //     } finally {
  //       //setLoading(false);
  //     }
  //   //seteditModal(true);
  // }
  console.log("trackingData", PaymentData);
  const [orderProcessing, setOrderProcessing] =  useState(false);
  const handleOrderProcessing = ()=> {
    setOrderProcessing(true)
  }
  const closeOrderProcessing = ()=> {
    setOrderProcessing(false)
  }
  return (
    <>
      <div className="product-container">
        <div className="container">
          <div className="px-5 py-3">
            {/* Show loader while loading */}
            {Loading ? (
              <Loader />
            ) : (
              <>
                <h2 className="text-3xl font-bold mb-1">My Orders</h2>
                <p className="text-gray-600 text-sm mb-4 text-muted-foreground">
                  Track your orders and download invoices
                </p>

                {/* Check if there are orders */}
                {orders.length > 0 ? (
                  orders.map((order) => (
                    <div className="custom-card p-4 mb-3" key={order?.user_order_id}>
                      <div className="d-flex align-items-center justify-content-between ccs-header">
                        <div>
                          <div className="text-lg font-semibold mb-1">
                            {order?.items?.[0]?.product_name || "No Product Name"}
                            <span className="status-tag" style={{ backgroundColor: getStatusClass(order?.status) }}>
                              {order?.status || "Unknown Status"}
                            </span>
                            <span className="status-tag">
                              {order?.orderId || ""}
                            </span>
                            <span className="status-tag">
                              ₹{order?.total_price || ""}
                            </span>

                          </div>
                          <div className="text-gray-600 text-sm">
                            {order?.orderDate || "No Date Available"}
                          </div>
                        </div>
                        <div>
                          {order?.payment_status === "Success" && (
                            <button
                              type="button"
                              className="btn btn--form update-profile-btn"
                              onClick={() => fetchInvoice(order?.user_order_id)}
                              disabled={loadingStates[order?.user_order_id]}
                            >
                              {loadingStates[order?.user_order_id] ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" style={{ width: "1.2rem", height: "1.2rem", borderWidth: "0.15rem", verticalAlign: "-4px" }} role="status" aria-hidden="true"></span>
                                  Downloading...
                                </>
                              ) : (
                                "Download Invoice"
                              )}
                            </button>
                          )}
                        </div>
                      </div>

                      {/* Progress bar */}
                      <div 
  className="progress custom-progress my-3" 
  role="progressbar" 
  aria-label="Order Progress" 
  aria-valuenow={
    order?.status === "Pending" ? 25 : 
    order?.status === "Placed" ? 75 : 
    order?.status ? 100 : 0
  }
  aria-valuemin="0" 
  aria-valuemax="100"
>
  <div 
    className="progress-bar" 
    style={{ 
      width: `${
        order?.status === "Pending" ? 25 : 
        order?.status === "Placed" ? 75 : 
        order?.status ? 100 : 0
      }%` 
    }}
  ></div>
</div>



                      {/* Order Details */}
                      <div className="row mt-4">
                        {/* Tracking Status */}
                        <div className="col-md-4 mb-4 mb-md-0">
                          <div className="text-md font-semibold mb-2 order-icon">
                            <BsBoxSeam /> Tracking Status
                          </div>
                          <button
                            type="button"
                            className="custom-card view-tracking-btn text-sm text-black d-flex align-items-center justify-content-between"
                             onClick={() => fetchOrderTracking(order?.user_order_id, order?.items)}
                            // onClick={fetchOrderTracking}
                            disabled={loadingTrackingStates[order?.user_order_id]}// Disable button while loading
                          >                                          <GrLocation />    {loadingTrackingStates[order?.user_order_id] ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" style={{ width: "1.2rem", height: "1.2rem", borderWidth: "0.15rem", verticalAlign: "-4px" }} role="status" aria-hidden="true"></span>
                              Processing...
                            </>
                          ) : (
                            "View Tracking"
                          )}
                            <MdOutlineNavigateNext />
                          </button>
                        </div>

                        {/* Shipping Address */}
                        <div className="col-md-4 mb-4 mb-md-0">
                          <div className="text-md font-semibold mb-2 order-icon">
                            <GrLocation /> Shipping Address
                          </div>
                          <div className="text-muted-foreground text-semibold text-sm">
                            {order?.full_address || "No Address Provided"}
                          </div>
                        </div>

                        {/* Payment Details */}
                        <div
                          className="col-md-4 mb-4 mb-md-0 cursor-pointer"
                        >
                          <div
                            className="text-md font-semibold mb-2 order-icon cursor-pointer text-blue-600 hover:underline hover:text-blue-800 transition"
                          >
                            <MdOutlineCreditCard className="inline-block mr-1" /> Payment Details
                          </div>

                          {/* <div className="text-muted-foreground text-sm">
                            {order?.payment_status === "Success" ? "Payment Available" : "Payment Method Not Available"}
                          </div> */}
                          <button
                            type="button"
                            className="btn btn--form update-profile-btn sm-btn"
                            onClick={() => handleViewTrackingBtn(order?.user_order_id)}
                            disabled={loadingPaymentState[order?.user_order_id]}// Disable button while loading
                          >

                            {loadingPaymentState[order?.user_order_id] ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" style={{ width: "1.2rem", height: "1.2rem", borderWidth: "0.15rem", verticalAlign: "-4px" }} role="status" aria-hidden="true"></span>
                                Processing...
                              </>
                            ) : (
                              order?.payment_status === "Success" ? "Payment Method Available" : "Payment Method Not Available"
                            )}
                          </button>
                        </div>

                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-gray-500">No orders found.</p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/* // Old Code */}
      {/* <div className="orders-container">
        <h2 className="orders-title">Your Orders</h2>
        {Loading && (
          <>
            <Loader />
          </>
        )}
        <div className="search-box">
          <input
            type="text"
            placeholder="Search your orders here"
            className="search-input"
          />
          <button className="search-button">🔍</button>
        </div>

        <div className="orders-list">
          {orders.map((order) => (
            <div key={order._id} className="order-card">
              <img src={order?.items[0]?.product_image} alt={order[0]?.items[0]?.product_name} className="order-image" />
              <div className="order-details">
                <h3 className="order-name">{order?.items[0]?.product_name}</h3>
                <p className="order-price">{order.total_price}</p>
                <p className={`order-status ${order.status.toLowerCase()}`}>
                  {order.status} on {order.orderDate}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <Modal isOpen={editModal} toggle={() => seteditModal(false)} size="lg">
        <ModalHeader toggle={() => seteditModal(false)}>
          Payment Details
        </ModalHeader>
        <ModalBody>
          {Loading ? (
            <div className="text-center">Loading...</div>
          ) : PaymentData ? (
            <div className="row">
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>RRN</div>
                <div className='text-md font-semibold'>{PaymentData?.acquirer_data?.rrn || "Not available yet"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Amount</div>
                <div className='text-md font-semibold'>
                {PaymentData?.amount ? `₹${PaymentData.amount / 100}` : "To be determined"}
              </div>

              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Amount Refunded</div>
                <div className='text-md font-semibold'>{PaymentData?.amount_refunded || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Bank</div>
                <div className='text-md font-semibold'>{PaymentData?.bank || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Base Amount</div>
                <div className='text-md font-semibold'>{PaymentData?.base_amount ? `₹${PaymentData.base_amount / 100}` : "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Captured</div>
                <div className='text-md font-semibold'>{PaymentData?.captured || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Contact Number</div>
                <div className='text-md font-semibold'>{PaymentData?.contact || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Created At</div>
                <div className='text-md font-semibold'>{PaymentData?.created_at || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Currency</div>
                <div className='text-md font-semibold'>{PaymentData?.currency || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Description</div>
                <div className='text-md font-semibold'>{PaymentData?.description || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Email</div>
                <div className='text-md font-semibold'>{PaymentData?.email || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Entity</div>
                <div className='text-md font-semibold'>{PaymentData?.entity || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Fee</div>
                <div className='text-md font-semibold'>{PaymentData?.fee || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>International</div>
                <div className='text-md font-semibold'>{PaymentData?.international || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Method</div>
                <div className='text-md font-semibold'>{PaymentData?.method || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>OrderID</div>
                <div className='text-md font-semibold'>{PaymentData?.order_id || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Refund Status</div>
                <div className='text-md font-semibold'>{PaymentData?.refund_status || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Reward</div>
                <div className='text-md font-semibold'>{PaymentData?.reward || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Status</div>
                <div className='text-md font-semibold'>{PaymentData?.status || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Tax</div>
                <div className='text-md font-semibold'>{PaymentData?.tax || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>VPA</div>
                <div className='text-md font-semibold'>{PaymentData?.upi?.vpa || "To be determined"}</div>
              </div>
              <div className='col-md-4 col-sm-6 col-6 mb-3'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Wallet</div>
                <div className='text-md font-semibold'>{PaymentData?.wallet || "To be determined"}</div>
              </div>
              {/* <div className='col-12'>
                <hr />
              </div>
              <div className='col-12'>
                <div className='text-muted-foreground text-semibold text-sm mb-1'>Tracking Updates</div>
                {PaymentData.trackingUpdates?.length > 0 ? (
                  PaymentData.trackingUpdates.map((update, index) => (
                    <div key={index} className="tracking-step">
                      <div className="status-icon"></div>
                      <div className="tracking-info">
                        <p className="font-semibold text-lg">{update.status}</p>
                        <p className="text-xs text-muted-foreground my-0">{update.date}</p>
                        <p className="text-sm text-muted-foreground my-1">{update.description}</p>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='text-md font-semibold text-muted-foreground ps-4 py-3'>No tracking updates available yet</div>
                )}
              </div> */}
            </div>
          ) : (
            "Payment Method Data Not Available"
          )}
        </ModalBody>
      </Modal>
      {/* Order Processing */}
      <div className={`cs-alert-popup overlay ${!orderProcessing && "d-none"}`}>
        <div className="popup">
          <button className="close-btn" onClick={closeOrderProcessing}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>

          <div className="header">
            <div className="icon-wrapper">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
              </svg>
            </div>
            <h3 className="title">Order Processing</h3>
            <p className="subtitle">Tracking will be available once your order ships</p>
          </div>

          <div className="content">
            <div className="progress-section">
              <div className="progress-labels">
                <span>Order Processing</span>
                <span>Shipping</span>
              </div>
              <div className="progress custom-progress my-3" role="progressbar" aria-label="Order Progress" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                <div className="progress-bar" style={{ width: "25%" }}></div>
              </div>
            </div>

            <div className="status-grid">
              <div className="status-item btn--form buy-now-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
                <span>Processing</span>
              </div>
              <div className="status-item btn btn--form update-profile-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span>Not Shipped</span>
              </div>
            </div>

            <div className="info-box">
              <img src={orderItems[0]?.product_image}
                alt="Package Processing"
                className="info-image" />
              <div class="info-text">
                <h4>Your order is being prepared</h4>
                <p>We'll notify you when your order ships and tracking becomes available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrdersList;
